// extracted by mini-css-extract-plugin
module.exports = {"search-title":"_356GN","button-container":"_3D05w"};